<template>
  <amplify-connect :query="getNewsArticleQuery">
    <template slot-scope="{loading, data, errors}">
      <fin-logo-full dark loading v-if="loading"></fin-logo-full>

      <div v-else-if="errors.length > 0">TODO error: {{errors}}</div>

      <div v-else-if="data">
        <fin-news-details :value="data.getNewsArticle" @close="()=> goBack({name: 'news'})"/>
      </div>
    </template>
  </amplify-connect>
</template>

<script>
import finNewsDetails from '@/components/pages/finNews/detail/NewsDetails.vue'
import GoBackMixin from '@/mixins/GoBack'
import { getNewsArticle } from '@/js/finQueries'
import FinLogoFull from '@/components/common/logo/LogoFull/index'

export default {
  name: 'NewsDetail',
  components: { finNewsDetails, FinLogoFull },
  mixins: [GoBackMixin],
  props: {
    id: {
      type: String
    }
  },
  computed: {
    getNewsArticleQuery () {
      return this.$Amplify.graphqlOperation(getNewsArticle, { id: this.id })
    }
  }
}
</script>
